var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-scroll-bar", attrs: { id: "app" } }, [
    _vm.loading
      ? _c("div", { staticClass: "loader-container" }, [
          _c("div", { staticClass: "loader" }),
        ])
      : _vm._e(),
    _c(
      "div",
      {
        staticClass: "main app-scroll",
        class: { "is-login": _vm.$isLogIn, "is-logout": !_vm.$isLogIn },
      },
      [
        _c("navbar", {
          attrs: { isShowSidebar: _vm.isShowSidebar },
          on: { onUpdateSidebar: _vm.handleSidebarChanges },
        }),
        _c("sidebar", {
          attrs: { isShowSidebar: _vm.isShowSidebar },
          on: { onUpdateSidebar: _vm.handleSidebarChanges },
        }),
        _c(
          "div",
          { staticClass: "main-container", style: _vm.mcStyles },
          [_c("breadcrumb"), _c("router-view")],
          1
        ),
        _c("planning-footer", { class: { "d-none": _vm.$isFullscreen } }),
      ],
      1
    ),
    _c("div", { staticClass: "v-bar" }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }